import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=a6c53ea2&scoped=true&"
import script from "./TextEdit.vue?vue&type=script&lang=ts&"
export * from "./TextEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TextEdit.vue?vue&type=style&index=0&id=a6c53ea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c53ea2",
  null
  
)

export default component.exports